import r from "../managers/braze-instance.js";
import { validateStandardString as er } from "../util/validation-utils.js";
export function setSdkAuthenticationSignature(t) {
  if (!r.rr()) return !1;
  if ("" === t || !er(t, "set signature", "signature", !1)) return !1;
  const i = r.Sr();
  return !!i && (i.setSdkAuthenticationSignature(t), !0);
}
